<div class="classroom-card" [class.mobile]="deviceService.isMobile()">
  <div class="cover">
    <ng-container *ngTemplateOutlet="cover"></ng-container>
  </div>
  <div class="meta">
    <ng-container *ngTemplateOutlet="meta"></ng-container>
  </div>
</div>

<ng-template #cover>
  <div class="access-type" *ngIf="isPrivate">{{ 'classrooms.form.access.private' | translate }}</div>
  <on-ui-cover [cover]="coverImg()"></on-ui-cover>
</ng-template>

<ng-template #meta>
  <div class="header">
    <ng-container *ngTemplateOutlet="header"></ng-container>
  </div>
  <div class="title">
    <a class="link" [routerLink]="classroomRoute(classroom)">{{ title | translate }}</a>
  </div>
  <div class="description" *ngIf="classroom.description">
    {{ classroom.description }}
  </div>
  <div class="edit-link" *ngIf="classroom?.can?.edit">
    <p (click)="onToggleEditForm()">{{ 'classrooms.menu.edit' | translate }}</p>
  </div>
</ng-template>

<ng-template #header>
  <div class="type">
    {{ 'classrooms.types.classroom' | translate }}
  </div>
  <div class="actions">
    <ng-container *ngTemplateOutlet="actions"></ng-container>
  </div>
</ng-template>

<ng-template #actions>
  <div class="participants-counter">
    <ng-container *ngIf="isMe; else count">
      <app-icon
        class="participants-icon-new"
        icon="classroom-participants-new"
        [width]="24"
        [height]="30"
        (click)="openInviteModal()"
      ></app-icon>
    </ng-container>
    <ng-template #count>
      <app-icon
        class="participants-icon"
        icon="classroom-participants"
        [width]="32"
        [height]="32"
      ></app-icon>
    </ng-template>
    {{ classroom.stats.accepted }}
  </div>
  <on-ui-card-menu>
    <ng-container *ngTemplateOutlet="menuPopover"></ng-container>
  </on-ui-card-menu>
</ng-template>

<ng-template #menuPopover>
      <div class="menu-item" *ngIf="userService?.purl"><a [href]="userService?.purl">[⚠️] Panel [service]</a></div>
      <div class="menu-item" *ngIf="contract?.purl"><a [href]="contract?.purl">[⚠️] Panel [contract]</a></div>
      <ng-container *ngFor="let option of options; trackBy: trackByFn">
        <div class="menu-item" *ngIf="isEnabledMenuOption(option)"
            (click)="onAction(option)">{{ option.label | translate }}</div>
      </ng-container>
      <ng-container *ngIf="classroom?.user_service_contract?.can?.break">
        <div class="menu-item danger"
            [attr.data-test]="'break-user-service-contract'"
            (click)="onContractBreak()">
          {{userService.type === EUserServiceType.course || userService.type === EUserServiceType.mini
          ? ('classrooms.classroom-page.decline-participant' | translate)
          : userService.type === EUserServiceType.regular
            ? ('classrooms.classroom-page.cancel-subscription' | translate)
            : 'classrooms.classroom-page.cancel' | translate}}</div>
      </ng-container>
</ng-template>

<ng-template [ngIf]="inviteModal">
  <app-modal *ngIf="!deviceService.isMobile(); else mobileInviteForm"
             [canClose]="false"
             [middle]="true"
             (closed)="closeInviteModal()">
    <app-modal-body>
      <app-invite-to-classroom [classroom]="classroom"
                               (invited)="onParticipantsInvited()">
      </app-invite-to-classroom>
    </app-modal-body>
  </app-modal>

  <ng-template #mobileInviteForm>
    <app-mobile-modal (closed)="closeInviteModal()">
      <app-mobile-modal-title>{{ 'classrooms.invite.title' | translate }}</app-mobile-modal-title>
      <app-mobile-modal-body>
        <app-invite-to-classroom [classroom]="classroom"
                                 (invited)="onParticipantsInvited()">
        </app-invite-to-classroom>
      </app-mobile-modal-body>
    </app-mobile-modal>
  </ng-template>
</ng-template>

<ng-template [ngIf]="classroomModalOpened">
  <app-modal (closed)="onToggleEditForm()"
             *ngIf="!deviceService.isMobile()"
             [canClose]="false">
    <app-modal-body>
      <app-classroom-form-wrapper (canceled)="onToggleEditForm()"
                                  (saved)="onSavedClassroom()"
                                  [classroom]="classroom">
      </app-classroom-form-wrapper>
    </app-modal-body>
  </app-modal>

  <app-mobile-modal (closed)="onToggleEditForm()" *ngIf="deviceService.isMobile()">
    <app-mobile-modal-title>{{ (classroom?.id ? 'classrooms.form.titles.edit' : 'classrooms.form.titles.create') | translate }}</app-mobile-modal-title>
    <app-mobile-modal-body>
      <app-classroom-form-wrapper (canceled)="onToggleEditForm()"
                                  (saved)="onSavedClassroom()"
                                  [classroom]="classroom">
      </app-classroom-form-wrapper>
    </app-mobile-modal-body>
  </app-mobile-modal>
</ng-template>

<app-alert *ngIf="classBreakAlertShow && alertData" type="warning">
  <ng-container alert-title>{{alertData.title | translate}}</ng-container>
  <ng-container alert-body>{{alertData.description | translate}}</ng-container>
  <ng-container alert-buttons>
    <on-ui-button class="primary outline"
                  [label]="alertData.closeBtnText"
                  (onclick)="classBreakAlertShow = false">

    </on-ui-button>
    <on-ui-button class="primary"
                  [label]="alertData.confirmBtnText"
                  (onclick)="breakContract()">
    </on-ui-button>
  </ng-container>
</app-alert>
